import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { loginValidateSchema } from "../Util/formValidations";
import { useDispatch } from "react-redux";
import { signinAction } from "../Redux/Action/AuthAction";
import { clearTimes, storeUser } from "../Redux/Slice/authSlice";
import { toast } from "react-hot-toast";
export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch()
const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginValidateSchema,
    onSubmit: async (values) => {
      if (values) {
        setIsLoading(true);
        const modifyData = {
         email: values.email,
         password:values.password,
       }
        const result = await dispatch(signinAction(modifyData))
        if(result?.payload?.statusCode == 200){
          dispatch(storeUser(result?.payload?.data))
          localStorage.setItem("token",result?.payload?.data?.token)
          if(result?.payload?.data?.isTemporaryPassword === true){
            // navigate("/update-password");
            dispatch(clearTimes());
            window.location.href = "/update-password";
            toast.success("Login successful.",{
              iconTheme: {
                primary: '#4318ff',
                secondary: '#FFFAEE',
              },
            }) ;
            setIsLoading(false);
          }else{
            dispatch(clearTimes());
        
            setIsLoading(false);
            toast.success("Login successful.",{
              iconTheme: {
                primary: '#4318ff',
                secondary: '#FFFAEE',
              },
            }) ;
            navigate("/Dashboard");
            // debugger
            // window.location.href = "/Dashboard";
          }
         
        }else{
          toast.error(result?.payload?.message) ;
          setIsLoading(false);
        }
      }

    }
  })
  return (
    <div className="cmn-gradient">
      <div className="sign-shape">
        <Container fluid>
          <Row className="box-center">
            <Col lg={5} className="m-auto">
              <div className="login-cmn-box">
                <div className="login-box-inner-wrap">
                  <h2 className="">Peerscroller Teacher Portal</h2>
                  <p>Enter your email and password to sign into the Teacher Portal. If you haven’t received an invitation to the Portal yet, speak to your organisation’s administrator.</p>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="form-set">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email*</Form.Label>
                        <Form.Control type="email"
                          placeholder="Type Here"
                          name="email"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                        />
                        {formik.submitCount > 0 && formik.errors.email && (
                          <div className="error text-danger">{formik.errors.email}</div>
                        )}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Password*</Form.Label>
                        <Form.Control type="password"
                          placeholder="Type Here"
                          name="password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.password}
                        />

                        {formik.submitCount > 0 && formik.errors.password && (
                          <div className="error text-danger">{formik.errors.password}</div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="form-check-box">
                      <Form.Group className="" controlId="formBasicCheckbox">
                        {/* <Form.Check type="checkbox" label="Keep me logged in" /> */}
                      </Form.Group>
                      <Link to="/forgot-password" className="forgot m-0">
                         Forgot your password?
                      </Link>
                    </div>
                    <button
                      // to="/otp"
                      variant="primary"
                      type="submit"
                      className="submit"
                      disabled={isLoading ? true :false}
                    >
                    
                      {isLoading ? "loading..." :"Sign In"}
                    </button>
                  </Form>
                </div>
              </div>
            </Col>
            <Col lg={7} className="d-flex justify-content-center">
              <img
                style={{ opacity: "0.6" }}
                src={require("../Assets/Images/signin-logo.png")}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
